import React from "react";
import MembersAccessPage from "../../../distributor-settings/members-access";
import styles from "./distributor-members.module.scss";

const DistributorMembers = () => {
  return (
    <div className={styles.container}>
      <MembersAccessPage isDistributorView={true} />
    </div>
  );
};

export default DistributorMembers;
